/** @jsx jsx */
import React, { useEffect, useState } from "react"
import { jsx, Flex, Container, Button, Box } from "theme-ui"
import { ToastContainer } from "react-toastify"
import { GatsbyImage } from "gatsby-plugin-image"
import Nav from "./Nav"
import MobileNav from "./MobileNav"
import Footer from "./Footer"
import Cookies from "js-cookie"
import "react-toastify/dist/ReactToastify.min.css"
import ContentfulRichText from "./shared/ContentfulRichText"
import Action from "./shared/Action"
import useTrackWindowSize from "../hooks/useTrackWindowSize"

const Layout = ({ children, bannerData, navName, mainContainerClass }) => {
  const { desktop } = useTrackWindowSize()


  const [show, setShow] = useState(false)
  useEffect(() => {
    if (!Cookies.get("bannerDismissed")) {
      setShow(true)
    }
  }, [])

  const handleClose = () => {
    setShow(false)
    Cookies.set("bannerDismissed", "true") // Session cookie
  }
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
      <header
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          backgroundColor: "white",
          opacity: 0.95,
        }}
      >
        {desktop && <Nav navName={navName} />}
        {!desktop && <MobileNav />}
      </header>
      {show && bannerData && (
        <Container sx={{ position: "sticky", top: "100px", zIndex: 1 }}>
          <Flex
            sx={{
              borderLeft: "10px solid #223F99",
              borderRadius: "4px",
              boxShadow: "0px 4px 2px #00000027",
              background: "#F4F4F7 0% 0% no-repeat padding-box",
              height: ["fit-content", "50px"],
              justifyContent: ["center", "space-between"],
              flexDirection: ["row"],
              alignItems: ["flex-start", "center"],
              gap: "10px",
            }}
          >
            <Flex
              sx={{
                justifyContent: "space-between",
                alignItems: ["flex-start", "center"],
                width: "100%",
              }}
            >
              {bannerData.bannerImage && (
                <GatsbyImage
                  sx={{
                    width: "20px",
                    marginRight: "10px",
                  }}
                  image={bannerData.bannerImage.gatsbyImageData}
                  alt="banner image"
                />
              )}
              <Box sx={{ px: "10px", flexGrow: "1" }}>
                <ContentfulRichText richText={bannerData?.bannerText} />
              </Box>
              <Flex sx={{ py: "8px", justifyContent: "center", minHeight: "50px", alignItems: "center" }}>
                <Action
                  label={bannerData.label}
                  style="button secondaryV2"
                  actionEvent="link"
                  url={bannerData.link}
                  sx={{ fontSize: "18px", fontWeight: 600 }}
                />
              </Flex>
            </Flex>
            <Button
              sx={{
                background: "transparent",
                color: "#9d9d9f",
                fontWeight: "normal",
                display: "inline-flex",
                pl: "10px",
                pt: "10px",
              }}
              onClick={handleClose}
            >
              x
            </Button>
          </Flex>
        </Container>
      )}
      <main className={mainContainerClass || "site-content"}>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
